export default __webpack_public_path__ + "static/media/mobile_app.e72ba705.svg";